import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icons } from "../../constants/icon-library";
import { toast } from "react-toastify";
import { getIcon } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { createIntegrationRequestAction } from "../../features/integration-request/integrationRequestSlice";
import { useFormik } from "formik";

function ComingSoon() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.integrationRequest);

  const { platformName, assistant } = location.state || {};

  let iconSrc = getIcon(platformName);
  if (!iconSrc) {
    iconSrc = assistant?.platform?.iconUrl;
  }

  const platformId = assistant?.platform?.uuid;

  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.reason.trim()) {
        errors.reason = "Please enter a reason";
      }
      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      const payload = {
        reason: values.reason,
        platformId,
      };

      const res = await dispatch(createIntegrationRequestAction(payload));

      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Request submitted successfully");
        resetForm();
        navigate(-1);
      } else {
        toast.error("Failed to submit request");
      }
    },
  });

  return (
    <div className="container my-5">
      <div
        className="card border-0 shadow-lg"
        style={{ marginTop: "60px" }}
      >
        <div className="card-body p-4">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between pb-3 border-bottom border-secondary gap-2">
            <div className="d-flex align-items-center flex-grow-1 w-100 w-md-auto">
              <div
                className="rounded-circle bg-gradient d-flex justify-content-center align-items-center me-3 flex-shrink-0"
                style={{
                  width: "60px",
                  height: "60px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  boxShadow: "0 4px 15px rgba(102,126,234,0.4)",
                }}
              >
                <img
                  src={iconSrc}
                  alt={platformName}
                  style={{ width: "35px", height: "35px" }}
                />
              </div>

              <div className="d-flex flex-column flex-grow-1">
                <h3 className="mb-0 text-truncate">
                  {platformName || "Platform"}
                </h3>
                <small>
                  This integration is not available yet
                </small>
              </div>
            </div>
          </div>
          <form onSubmit={formik.handleSubmit} className="mt-4">
            <div className="mb-4">
              <label className="form-label">
                Please help us understand how this feature will help you so we
                can prioritise it
              </label>

              <textarea
                name="reason"
                className={`form-control ${
                  formik.touched.reason && formik.errors.reason
                    ? "is-invalid"
                    : ""
                }`}
                rows={8}
                value={formik.values.reason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Tell us your use case..."
              />

              {formik.touched.reason && formik.errors.reason && (
                <div className="invalid-feedback">{formik.errors.reason}</div>
              )}
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-phoenix-secondary text-body"
                onClick={() => navigate(-1)}
              >
                <i className={`wb ${Icons("previous")} me-1 align-middle`} />
                Back
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                <i className={`wb ${Icons("send")} me-1`} />
                {loading ? "Submitting..." : "Submit Request"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
